import React from 'react';

import './laboratoriesSVG.scss';

const LaboratoriesSVG = ({ width, height }) => (
	<svg
		version="1.1"
		x="0px"
		y="0px"
		width={width || '131px'}
		height={height || '100px'}
		viewBox="0 0 220 130"
		xmlSpace="preserve"
		id="laboratories"
	>
		<g id="head" />
		<g id="body">
			<path
				className="st0"
				d="M136.24,123.48H83.4V34.1c0-1.31,1.06-2.38,2.38-2.38h48.11c1.31,0,2.38,1.06,2.38,2.38v89.36
		C136.26,123.47,136.25,123.48,136.24,123.48z"
			/>
			<path
				className="st0"
				d="M124.44,31.53H95.72c-0.15,0-0.27-0.12-0.27-0.27v-7.54c0-0.82,0.66-1.48,1.48-1.48h25.92
		c1.02,0,1.85,0.83,1.85,1.85v7.17C124.71,31.41,124.59,31.53,124.44,31.53z"
			/>
			<path
				className="st1"
				d="M119.98,122.72h-19.7c-0.04,0-0.06-0.03-0.06-0.06V99.7c0-1.24,1.01-2.25,2.25-2.25h15.27
		c1.24,0,2.25,1.01,2.25,2.25V122.72z"
			/>
			<g id="Camada_4">
				<path className="st0" d="M190.07,123.48h-53.81V59.94h50.91c1.6,0,2.9,1.3,2.9,2.9V123.48z" />
				<path
					className="st1"
					d="M178.9,77h-30.88c-1.4,0-2.53-1.13-2.53-2.53v0c0-1.4,1.13-2.53,2.53-2.53h30.88c1.4,0,2.53,1.13,2.53,2.53v0
			C181.44,75.86,180.3,77,178.9,77z"
				/>
				<path
					className="st1"
					d="M178.9,88.49h-30.88c-1.4,0-2.53-1.13-2.53-2.53v0c0-1.4,1.13-2.53,2.53-2.53h30.88
			c1.4,0,2.53,1.13,2.53,2.53v0C181.44,87.36,180.3,88.49,178.9,88.49z"
				/>
				<path
					className="st1"
					d="M178.9,99.99h-30.88c-1.4,0-2.53-1.13-2.53-2.53v0c0-1.4,1.13-2.53,2.53-2.53h30.88
			c1.4,0,2.53,1.13,2.53,2.53v0C181.44,98.86,180.3,99.99,178.9,99.99z"
				/>
				<path
					className="st1"
					d="M178.9,111.49h-30.88c-1.4,0-2.53-1.13-2.53-2.53l0,0c0-1.4,1.13-2.53,2.53-2.53h30.88
			c1.4,0,2.53,1.13,2.53,2.53l0,0C181.44,110.35,180.3,111.49,178.9,111.49z"
				/>
			</g>
			<g id="Camada_5">
				<path className="st0" d="M83.4,123.48H29.96V62.93c0-1.65,1.34-2.99,2.99-2.99H83.4V123.48z" />
				<path
					className="st1"
					d="M72.12,76.72H41.24c-1.4,0-2.53-1.13-2.53-2.53v0c0-1.4,1.13-2.53,2.53-2.53h30.88c1.4,0,2.53,1.13,2.53,2.53
			v0C74.65,75.58,73.52,76.72,72.12,76.72z"
				/>
				<path
					className="st1"
					d="M72.12,88.21H41.24c-1.4,0-2.53-1.13-2.53-2.53l0,0c0-1.4,1.13-2.53,2.53-2.53h30.88
			c1.4,0,2.53,1.13,2.53,2.53l0,0C74.65,87.08,73.52,88.21,72.12,88.21z"
				/>
				<path
					className="st1"
					d="M72.12,99.71H41.24c-1.4,0-2.53-1.13-2.53-2.53l0,0c0-1.4,1.13-2.53,2.53-2.53h30.88
			c1.4,0,2.53,1.13,2.53,2.53l0,0C74.65,98.57,73.52,99.71,72.12,99.71z"
				/>
				<path
					className="st1"
					d="M72.12,111.2H41.24c-1.4,0-2.53-1.13-2.53-2.53v0c0-1.4,1.13-2.53,2.53-2.53h30.88c1.4,0,2.53,1.13,2.53,2.53
			v0C74.65,110.07,73.52,111.2,72.12,111.2z"
				/>
			</g>
			<g id="Camada_3">
				<path
					className="st0"
					d="M197.55,136.17H19.04c-3.28,0-5.94-2.66-5.94-5.94v0c0-3.28,2.66-5.94,5.94-6.54h178.51
			c3.28,0.6,5.94,3.26,5.94,6.54v0C203.49,133.5,200.83,136.17,197.55,136.17z"
				/>
			</g>
		</g>
		<g id="Camada_6">
			<path
				className="st1"
				d="M125.54,47.22H94.66c-1.4,0-2.53-1.13-2.53-2.53v0c0-1.4,1.13-2.53,2.53-2.53h30.88c1.4,0,2.53,1.13,2.53,2.53
		v0C128.07,46.08,126.94,47.22,125.54,47.22z"
			/>
		</g>
		<g id="Camada_9">
			<path
				className="st1"
				d="M125.54,58.87H94.66c-1.4,0-2.53-1.13-2.53-2.53v0c0-1.4,1.13-2.53,2.53-2.53h30.88c1.4,0,2.53,1.13,2.53,2.53
		v0C128.07,57.74,126.94,58.87,125.54,58.87z"
			/>
		</g>
		<g id="Camada_8">
			<path
				className="st1"
				d="M125.54,70.37H94.66c-1.4,0-2.53-1.13-2.53-2.53v0c0-1.4,1.13-2.53,2.53-2.53h30.88c1.4,0,2.53,1.13,2.53,2.53
		v0C128.07,69.23,126.94,70.37,125.54,70.37z"
			/>
		</g>
		<g id="Camada_7">
			<path
				className="st1"
				d="M125.54,81.7H94.66c-1.4,0-2.53-1.13-2.53-2.53v0c0-1.4,1.13-2.53,2.53-2.53h30.88c1.4,0,2.53,1.13,2.53,2.53
		v0C128.07,80.57,126.94,81.7,125.54,81.7z"
			/>
		</g>
	</svg>
);

export default LaboratoriesSVG;
